/** 신년운세 > 목차 */
export const CONTENTS = [
  { id: 1, title: '📖 2026년은 고민과 방향이 중요해지는 한 해!' },
  { id: 2, title: '' },
  { id: 3, title: '1. 2026년 나의 흐름은 어떻게 바뀔까요?' },
  { id: 4, title: '' },
  { id: 5, title: '' },
  { id: 6, title: '' },
  { id: 7, title: '2. 2026년을 이해하는데 꼭 필요한 나만의 핵심 흐름?' },
  { id: 8, title: '3. 명리로 짚어보는 2026년, 나의 흐름 구조' },
  { id: 9, title: '4. 2026년 나는 어떤 성향의 흐름을 가질까요?' },
  { id: 10, title: '5. 올해, 나에게 유리한 방향' },
  { id: 10, title: '6. 올해, 에너지를 아껴도 괜찮은 방향' },
  { id: 11, title: '7. 2026년의 여정을 만들어가는 마음의 기준' },
];

/** 신년운세 > 페이지네이션 > 목차 인덱스: 페이지 매칭 */
export const CONTENTS_PAGE_MAP = {
  0: 1, // Guide01
  1: 3, // Contents01 (1. 2026년 나의 흐름은...)
  2: 7, // Contents04 (2. 2026년을 이해하는데...)
  3: 8, // Contents05 (3. 명리로 짚어보는...)
  4: 9, // Contents06 (4. 2026년 나는 어떤 성향...)
  5: 10, // Contents07 (5. 올해, 나에게 유리한 방향)
  6: 10, // Contents07 (6. 올해, 에너지를 아껴도...)
  7: 11, // Contents08 (7. 2026년의 여정을...)
};
